"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const imageInfoBannerInputs = [
  {
    name: "variant",
    type: "string",
    required: true,
    enum: [
      { label: "Default", value: "default" },
      { label: "Secondary", value: "secondary" },
    ],
    defaultValue: "default",
  },
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Ploom 3 in 1",
  },
  {
    name: "topRightText",
    friendlyName: "Text shown in right top corner",
    type: "string",
  },
  {
    name: "bottomText",
    friendlyName: "Button label",
    type: "string",
    required: true,
    defaultValue: "Click here",
  },
  {
    name: "url",
    friendlyName: "Button url",
    type: "url",
    required: true,
    defaultValue: "#",
  },
  {
    name: "text",
    friendlyName: "Text above CTA button",
    type: "string",
  },
  {
    name: "backgroundImageSrc",
    friendlyName: "Background image",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fcf84d728c2864ead99ba24709b63db04",
  },
  {
    name: "backgroundImageSrcMedium",
    friendlyName: "Background image medium size",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "backgroundImageSrcBig",
    friendlyName: "Background image large size",
    type: "file",
    allowedFileTypes: IMAGE_FILE_TYPES,
  },
  {
    name: "altText",
    friendlyName: "Alt text",
    type: "string",
  },
  {
    name: "color",
    friendlyName: "Font color",
    type: "string",
    defaultValue: "white",
    enum: [
      { label: "White", value: "white" },
      { label: "Black", value: "black" },
    ],
  },
  {
    name: "buttonVariant",
    friendlyName: "Button variant",
    type: "string",
    required: true,
    defaultValue: "button",
    enum: [
      { label: "Primary", value: "button" },
      { label: "Secondary", value: "button-transparent" },
      { label: "Chevron", value: "chevron-link" },
    ],
  },
  {
    name: "isAnimated",
    friendlyName: "Should have animation on hover",
    type: "boolean",
    defaultValue: false,
  },
  {
    name: "hasGradient",
    friendlyName: "Should have top and bottom gradient applied",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const ImageInfoBannerComponent: RegisteredComponent = {
  name: "ImageInfoBanner",
  component: dynamic(async () =>
    withValidation(imageInfoBannerInputs, (await import("./ImageInfoBanner")).ImageInfoBanner, "ImageInfoBanner")
  ),
  inputs: imageInfoBannerInputs,
  noWrap: true, // we need to remove builder wrapper to target actual component not redundant div.
  canHaveChildren: false,
};
